import Content from "uxp-documentation/src/pages/uxp-api/reference-css/Selectors/Class selector";
import * as React from 'react';
export default {
  Content,
  React
};